/**
 * Header event models (portfolio / consumer side).
 * Duplicated from app header events — no import from header module.
 * Source: apps/kala-mobile/src/app/components/header/events/header-events.model.ts
 */

import { IconNames } from '@icon/assets';

export interface HeaderItemToHeader {
	iconName: IconNames;
	iconClass?: string;
	eventId: string;
	ariaLabel?: string;
	reloading?: boolean;
}

export interface HeaderConfigurationToHeader {
	showLogo?: boolean;
	title?: string;
	headerRightSectionItems?: HeaderItemToHeader[];
	headerLeftSectionItems?: HeaderItemToHeader[];
}

export interface HeaderActionEventFromHeader {
	eventId: string;
}

export const PORTFOLIO_HEADER_EVENTS = {
	HEADER_CONFIGURATION: 'header.configuration',
	HEADER_ACTION: 'header.action'
} as const;

/** The header's three-dot button — the way into the portfolio's own menu. */
export const PORTFOLIO_MENU_EVENT_ID = 'portfolio-menu';
